import { useState } from "react";
import { Service } from "../../models/WebsiteModels";
import PublicServiceModal from "./PublicServiceModal";
import { StageImage } from "./StagedImageLoading";

interface PublicServiceCardProps {
  service: Service;
}

const PublicServiceCard = ({ service }: PublicServiceCardProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="psite-service">
        <div className="psite-service__media">
          {service.imageUrl ? (
            <StageImage
              stage="services"
              src={service.imageUrl}
              alt={service.name}
            />
          ) : (
            <span>{service.name.charAt(0).toUpperCase()}</span>
          )}
        </div>
        <div className="psite-service__body">
          <h3>{service.name}</h3>
          <p>{service.description || "—"}</p>
          <button
            className="psite-btn psite-btn--primary psite-service__btn"
            onClick={() => setOpen(true)}
          >
            Details →
          </button>
        </div>
      </div>

      {open && (
        <PublicServiceModal
          service={service}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default PublicServiceCard;